import MainActivities from "../../components/MainActivities";
import { order } from "../SmartSearchParammeter";

export default async function MainActivitiesSearchConfig(key) {
  return {
    description: "Main Activities",
    id: "mainActivities",
    initial: undefined,
    type: order.third,
    handleValues: (searchObject) => {
      return;
    },

    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <MainActivities searchObject={searchObject} onChange={onChange} t={t} />
      </div>
    ),
    operation: ["Exact", "Like"],
    list: [],

    handler: function (searchObj, value) {
      searchObj["mainActivities"] = value[0];
    }
  };
}
